const countriesList = require("countries-list");

// COUNTRY CODES
const CANADA_ISO2 = "CA";
const ISRAEL_ISO2 = "IL";
const UNITED_STATES_ISO2 = "US";
const MEXICO_ISO2 = "MX";
const SPAIN_ISO2 = "ES";
const CHILE_ISO2 = "CL";
const PERO_ISO2 = "PE";
const ARGENTINA_ISO2 = "AR";
const BRAZIL_ISO2 = "BR";
const FRANCE_ISO2 = "FR";
const BELGIUM_ISO2 = "BE";
const GERMANY_ISO2 = "DE";
const AUSTRIA_ISO2 = "AT";
const SWITZERLAND_ISO2 = "CH";
const NETHERLANDS_ISO2 = "NL";
const ITALY_ISO2 = "IT";
const RUSSIA_ISO2 = "RU";
const JAPAN_ISO2 = "JP";
const KOREA_ISO2 = "KO";
const TURKEY_ISO2 = "TR";
const SWEDEN_ISO2 = "SV";
const BULGARIA_ISO2 = "BG";
const NORWAY_ISO2 = "NO";
const DENMARK_ISO2 = "DK";
const POLAND_ISO2 = "PL";
const LUXEMBOURG_ISO2 = "LU";
const HONG_KONG_ISO2 = "HK";
const ICELAND_ISO2 = "IS";
const TAIWAN_ISO2 = "TW";
const AUSTRALIA_ISO2 = "AU";
const UNITED_KINGDOM_ISO2 = "GB";
const IRELAND_ISO2 = "IE";
const SAUDI_ARABIA_ISO2 = "SA";
const NEW_ZEALAND_ISO2 = "NZ";

const NON_NATIVE_ENGLISH_COUNTRIES_ISO2 = [
  MEXICO_ISO2,
  SPAIN_ISO2,
  CHILE_ISO2,
  PERO_ISO2,
  ARGENTINA_ISO2,
  BRAZIL_ISO2,
  FRANCE_ISO2,
  CANADA_ISO2,
  BELGIUM_ISO2,
  GERMANY_ISO2,
  AUSTRIA_ISO2,
  SWITZERLAND_ISO2,
  NETHERLANDS_ISO2,
  ITALY_ISO2,
  RUSSIA_ISO2,
  JAPAN_ISO2,
  KOREA_ISO2,
  TURKEY_ISO2,
  SWEDEN_ISO2,
  POLAND_ISO2,
  HONG_KONG_ISO2,
  TAIWAN_ISO2
];

// CONTINENT CODES
const EUROPE = "EU";
const NORTH_AMERICA = "NA";

// REGION CODES
const EMEA_REGION = "EMEA";
const AUSTRALIA_NEW_ZEALAND_REGION = "ANZ";
const AMERICA_REGION = "AMERICA";

const CONTACT_SALES_REGIONS = {
  [EMEA_REGION]: [
    UNITED_KINGDOM_ISO2,
    FRANCE_ISO2,
    GERMANY_ISO2,
    ISRAEL_ISO2,
    NETHERLANDS_ISO2,
    SPAIN_ISO2,
    SWITZERLAND_ISO2,
    BELGIUM_ISO2,
    IRELAND_ISO2,
    SWEDEN_ISO2,
    AUSTRIA_ISO2,
    NORWAY_ISO2,
    DENMARK_ISO2,
    SAUDI_ARABIA_ISO2,
    TURKEY_ISO2,
    LUXEMBOURG_ISO2,
    ICELAND_ISO2,
    BULGARIA_ISO2
  ],
  [AUSTRALIA_NEW_ZEALAND_REGION]: [AUSTRALIA_ISO2, NEW_ZEALAND_ISO2],
  [AMERICA_REGION]: [UNITED_STATES_ISO2, CANADA_ISO2]
};

const FRENCH_SPEAKING_COUNTRIES = [FRANCE_ISO2, BELGIUM_ISO2, LUXEMBOURG_ISO2];
const GERMAN_SPEAKING_COUNTRIES = [GERMANY_ISO2, SWITZERLAND_ISO2, AUSTRIA_ISO2];

const getCountriesByContinent = (continentCode) => {
  const { countries } = countriesList;
  const countryCodes = Object.keys(countries);

  return countryCodes.filter((cc) => countries[cc].continent === continentCode);
};

const getContactSalesRegionByCountry = (countryCode) => {
  const regions = Object.keys(CONTACT_SALES_REGIONS);

  return regions.find((region) => CONTACT_SALES_REGIONS[region].includes(countryCode));
};

const isCountryInContinent = (countryCode, continentCode) => {
  return getCountriesByContinent(continentCode).includes(countryCode);
};

const getContientByCountry = (countryCode) => {
  const { countries } = countriesList;
  return countries[countryCode]?.continent;
};

module.exports = {
  // COUNTRIES ISO2
  CANADA_ISO2,
  UNITED_STATES_ISO2,
  ISRAEL_ISO2,
  NON_NATIVE_ENGLISH_COUNTRIES_ISO2,
  BRAZIL_ISO2,
  // CONTINENTS
  EUROPE,
  NORTH_AMERICA,
  // REGIONS:
  EMEA_REGION,
  AUSTRALIA_NEW_ZEALAND_REGION,
  AMERICA_REGION,
  // LANGUAGES:
  FRENCH_SPEAKING_COUNTRIES,
  GERMAN_SPEAKING_COUNTRIES,
  // FUNCTIONS
  getCountriesByContinent,
  isCountryInContinent,
  getContientByCountry,
  getContactSalesRegionByCountry
};
